// 使用：$t('page.key')、$t('component.key')
// 规范：通过页面、或者组件分组

export default {
  locale: 'zh-cn',
  common: {
   
  },
  components: {
   
  },
  page: {
    homepage:{
      home: 'Home',
      ac:'Agent Cooperation',
      aboutus:'About Us',

      title1:'Make Friends with Interesting People',
      detail1:'Sing, dance,chat,and always have friends around',

      videolive:'Video Live',
      videolive1:'Special effects gifts,',
      videolive2:'enthusiastic interaction',
      videolive3:'Make friends with talented anchors who can sing and dance',

      pk:'Passionate PK',
      pktext1:'Passionate and exciting',
      pktext2:'Watch talent competitions between anchors and support your favorite',

      vdparty:'Video Party',
      vdpartyt1:'Unlimited joy and excitement',
      vdpartyt2:'Face-to-face video chat with attractive friends',

      vcparty:'Voice Party',
      vcpartyt1:'Chat and make friends,play in various ways',
      vcpartyt2:'Make friends through voice chat and talk freely',


      flus:'Follow Us',


      page2text1:'CONTACT US',
      page2text2:'New Agency Cooperation',
      page2text3:'Business cooperation',
      page3text1:  'Joyo Live is a live streaming platform. We are dedicated to connecting friends from all over the world,creating a platform for showcasing talents, having fun, and interacting. We aim to help ordinary people fulfill their dreams of becoming stars.',
  },
  },
  router: {}
}
